<template lang="pug"></template>

<script>
export default {
    name: 'BotaoContratoRastreabilidadeCadastrante',
    componentOptions: {
        title: 'Contrato Rastreabilidade',
        actions: [
            [
                {
                    name: 'Contrato Rastreabilidade Vendedor',
                    iconClass: 'lyra-icon lyra-contrato-rastreabilidade',
                    showView: false,
                    action: 'ContratoRastreabilidadeCadastrante',
                    route: 'contrato-rastreabilidade'
                }
            ]
        ]
    },

    methods: {
        abrirContratoRastreabilidade() {
            if (this.$route.name !== 'contrato-rastreabilidade') {
                this.$router.push({ name: 'contrato-rastreabilidade' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
